import React, { useState } from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
    Box,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    useTheme,
    Divider,
    Skeleton,
    Typography
} from '@mui/material';
import { Close, Delete, Edit } from '@mui/icons-material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomButton from 'components/Fileds/CustomButton';
import CustomTypography from 'components/Fileds/CustomTypography';
import { useAddTimeSlotsCategoryMutation, useDeleteTimesSlotsCategoryMutation, useGetTimeSlotsCategoryQuery, useUpdateTimeSlotsCategoryMutation } from 'pages/timeSlots/services';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Category Name is required'),
});

const TimeSlotCategory = ({ open, onClose }) => {
    const theme = useTheme();
    const [formLoading, setFormLoading] = useState(false);
    
    const { data: categoryList, isLoading: isLoadingList } = useGetTimeSlotsCategoryQuery();
    const [addTimeCategory] = useAddTimeSlotsCategoryMutation();
    const [updateTimeCategory] = useUpdateTimeSlotsCategoryMutation();
    const [deleteTimeCategory] = useDeleteTimesSlotsCategoryMutation();

    const [editItem, setEditItem] = useState(null);
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);

    const handleDeletePrompt = (id) => {
        setConfirmDeleteId(id);
        setTimeout(() => setConfirmDeleteId(null), 3000);
    };

    const handleEdit = (item, setFieldValue) => {
        setEditItem(item);
        setFieldValue('name', item.name);
    };

    const handleDelete = async (id) => {
        await deleteTimeCategory(id);
        setConfirmDeleteId(null);
        // refetch();
    };

    const handleSubmit = async (values, { resetForm }) => {
        setFormLoading(true);
        try {
            if (editItem) {
                await updateTimeCategory({ id: editItem.id, name: values.name }).unwrap();
            } else {
                await addTimeCategory({ name: values.name }).unwrap();
            }
            resetForm();
            setEditItem(null);
            onClose();
        } catch (error) {
            console.error('Submit Error:', error);
        } finally {
            setFormLoading(false);
        }
    };

    const handleCloseModal = () => {
        setEditItem(null);
        onClose();
    }

    return (
        <Dialog
            open={open}
            onClose={handleCloseModal}
            maxWidth="xs"
            fullWidth
            className="generic-dialog-container"
            PaperProps={{ sx: { borderRadius: '20px', padding: '0px', color: 'black' } }}
        >
            <Box className='d-flex align-items-center justify-content-center' sx={{ m: 0, p: 2, paddingTop: '20px' }}>
                <CustomTypography
                    variant="h5"
                    label={'Time Slot Categories'}
                    sx={{ fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main, mb: 0 }}
                />
                <IconButton aria-label="close" onClick={handleCloseModal} className='close-icon-container'>
                    <Close />
                </IconButton>
            </Box>

            <Formik
                enableReinitialize
                initialValues={{ name: editItem?.name || '' }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isValid }) => {
                    return (
                        <Form>
                            <DialogContent sx={{ padding: '0px' }}>
                                {/* Input and Button in same row */}
                                <Box className='d-flex align-items-center' sx={{ padding: '10px 24px' }} gap={3} mb={2}>
                                    <CustomTextField
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        fullWidth
                                        placeholder="Enter Category Name"
                                        error={touched.name && Boolean(errors.name)}
                                        helperText={touched.name && errors.name}
                                    />
                                    <CustomButton
                                        type='submit'
                                        fullWidth
                                        disabled={!isValid || formLoading}
                                        loading={formLoading}
                                        sx={{ borderRadius: "10px", width: "150px", py: 2.1, height: '45px' }}
                                    >
                                        {editItem ? 'UPDATE' : 'ADD'}
                                    </CustomButton>
                                </Box>
                                <Divider />
                                {/* Category List */}
                                <List sx={{ padding: '0px 20px', paddingBottom: '30px' }}>
                                    {/* {categoryList?.data?.records?.map((item) => (
                                        <ListItem key={item.id} divider>
                                            <ListItemText primary={item.name} />
                                            <ListItemSecondaryAction sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleEdit(item, setFieldValue)}
                                                >
                                                    <Edit fontSize="small" sx={{ color: '#1297DE' }} />
                                                </IconButton>
                                                {confirmDeleteId !== item.id && <IconButton
                                                    size="small"
                                                    onClick={() => handleDeletePrompt(item.id)}
                                                >
                                                    <Delete fontSize="small" sx={{ color: '#FF0202' }} />
                                                </IconButton>}
                                                {confirmDeleteId === item.id && (
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="error"
                                                        onClick={() => handleDelete(item.id)}
                                                    >
                                                        Click to Delete
                                                    </Button>
                                                )}
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))} */}


                                    {isLoadingList ? (
                                        Array.from(new Array(5)).map((_, index) => (
                                            <ListItem className='justify-content-between' key={index} divider>
                                                <Skeleton variant="text" width="100%" height={30} />
                                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                      <Skeleton variant="circular" width={22} height={22} sx={{ mx: 0.5 }} />
                                                      <Skeleton variant="circular" width={22} height={22} sx={{ mx: 0.5 }} />
                                                    </Box>
                                            </ListItem>
                                        ))
                                    )
                                    : categoryList?.data?.records?.length > 0 ? (
                                        categoryList?.data?.records?.map((item) => (
                                            <ListItem key={item.id} divider>
                                                <ListItemText primary={item.name} />
                                                <ListItemSecondaryAction sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                    <IconButton size="small" onClick={() => handleEdit(item, setFieldValue)}>
                                                        <Edit fontSize="small" sx={{ color: '#1297DE' }} />
                                                    </IconButton>
                                                    {confirmDeleteId !== item.id ? (
                                                        <IconButton size="small" onClick={() => handleDeletePrompt(item.id)}>
                                                            <Delete fontSize="small" sx={{ color: '#FF0202' }} />
                                                        </IconButton>
                                                    ) : (
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            color="error"
                                                            onClick={() => handleDelete(item.id)}
                                                        >
                                                            Click to Delete
                                                        </Button>
                                                    )}
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))
                                        ) : (
                                            <ListItem>
                                                <ListItemText className='d-flex align-items-center justify-content-center' primary="No categories found." />
                                            </ListItem>
                                        )
                                    
                                    }
                                </List>
                            </DialogContent>
                        </Form>
                    )
                }}
            </Formik>
        </Dialog>
    );
};

export default TimeSlotCategory;
